<template>
  <yv-form-search
    :formSearch="baseFormSearch"
    :inlineSearchAction="true"
    :enableExport="false"
    @search="search"
    ref="formReport"
  >
    <template #search-actions="{ actions }">
      <md-button
        native-type="submit"
        @click.native.prevent="actions.search"
        class="md-info md-round"
        >{{ $t("common.search") }}
      </md-button>
    </template>
  </yv-form-search>
</template>

<script>
import YvFormSearch from "@/components/Base/YvFormSearch.vue";
import { attendanceStatus } from "../../../../helpers/text-helper";
import { service_paths } from "@/constants/Services";
import moment from "moment";
import { formatDateClient } from "../../../../helpers/datetime-helper";
import { mapGetters } from "vuex";
import queryHelper from "@/helpers/query-helper";
import { getId } from "@/helpers/utils";
import { hasValidRole } from "../../../../helpers/role-helper";
import Role from "@/constants/Role";

export default {
  components: { YvFormSearch },
  data() {
    return {
      baseFormSearch: [
        {
          label: this.$t("daily_attendance.date"),
          name: "range_date",
          value: [new Date(), new Date()],
          type: "date-range",
          width: 35
        },
        {
          label: this.$t("common.status"),
          name: "status[]",
          value: [],
          type: "checkbox-multi-select",
          options: [],
          trackBy: "statusId",
          displayField: "text",
          showSelectAll: true,
          width: 30
        },
        {
          label: this.$t("class.student_filter_id_fullname"),
          name: "user_id",
          value: "",
          displayValue: "",
          options: [],
          type: "autocomplete",
          fields: {
            text: "name",
            value: "id"
          },
          searchKey: "search",
          refetchOptions: this.fetchStudentOptsByClass,
          width: 35,
          isDisabled: false
        }
      ],
      selectedDateValue: ""
    };
  },

  created() {
    const status = [];
    for (let key in attendanceStatus) {
      status.push({ statusId: key, text: attendanceStatus[key] });
    }
    this.baseFormSearch[1].options = status;
    this.baseFormSearch[1].value = Object.keys(attendanceStatus);
    hasValidRole(this.userRole, [Role.Student, Role.Family])
      ? (this.baseFormSearch[2].isDisabled = true)
      : this.fetchStudentOptsByClass();
    let params = queryHelper.buildQuery(this.baseFormSearch);
    this.search(params);
  },
  computed: {
    ...mapGetters("user", {
      userRole: "role",
      userTz: "timezone",
      userInfo: "info"
    }),
    classId() {
      return this.$route.params.id;
    }
  },
  methods: {
    search(queryParams) {
      if (
        queryParams["status[]"].length === 5 ||
        queryParams["status[]"].length === 0
      ) {
        queryParams["status[]"] = "";
      }
      queryParams.class_id = this.classId;
      queryParams.start_date = moment(queryParams.range_date[0]).format(
        "YYYY-MM-DD 00:00:00"
      );
      queryParams.end_date = moment(queryParams.range_date[1]).format(
        "YYYY-MM-DD 23:59:59"
      );
      queryParams.class_status = "On-going";
      delete queryParams.range_date;
      this.$emit("dailySearch", queryParams);
    },
    async getDateOption() {
      let dates = await this.$axios
        .get(`${service_paths.classes}/${this.classId}/calendar`, {
          limit: 100
        })
        .then(response => response.data.data);
      if (dates.length) {
        this.dailySearch(dates);
      }
    },
    fetchStudentOptsByClass(queryObj) {
      return this.$axios
        .get(
          `${service_paths.classes}/${this.classId}/students`,
          queryObj,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(response => {
          let options = [];
          response.data.data.forEach(student => {
            options.push({
              id: getId(student),
              name: student.student_code
                ? `${student.full_name} - ${student.student_code}`
                : student.full_name
            });
          });
          this.baseFormSearch[2].options = options;
        });
    },
    isValidDate(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      return dateString.match(regEx) != null;
    },
    convertTimezone(time, zone) {
      const moment = require("moment-timezone");
      if (!time) return "";
      if (zone)
        return moment(time + " ZZ", "YYYY-MM-DD hh:mm:ss ZZ")
          .tz(zone === "UTC" ? this.userInfo.school.timezone : zone)
          .format(`YYYY-MM-DD HH:mm:ss`);
    },
    dailySearch(dates) {
      let result = dates.map(date => {
        const originalDate = date.end;
        const checkAllDay = this.isValidDate(date.end);
        let dateFormat = this.convertTimezone(
          moment(date.end)
            .utcOffset(0)
            .format("YYYY-MM-DD HH:mm:ss"),
          this.userTz
        );
        dateFormat = moment(dateFormat).format(`${formatDateClient}`);
        let rawDate = moment(date.end, "YYYY-MM-DD[T]HH:mm:ss");
        checkAllDay
          ? (rawDate = rawDate.format("YYYY-MM-DD 00:00:00"))
          : (rawDate = rawDate.format("YYYY-MM-DD HH:mm:ss"));
        return { id: date["_id"], name: dateFormat, rawDate, originalDate };
      });
      this.getFormSearch(result);
    },
    getFormSearch(result) {
      this.baseFormSearch[0].options = result.sort(
        (pevioustDate, currentDate) =>
          new Date(currentDate.originalDate) -
          new Date(pevioustDate.originalDate)
      );
      this.baseFormSearch[0].value = result[0].id;
      this.$emit("dailySearch", {
        class_id: this.classId,
        date: result[0].rawDate,
        status: Object.keys(attendanceStatus)
      });
    },
    onSelectedDate(dateId) {
      let dates = this.baseFormSearch[0].options;
      this.selectedDateValue = dates.find(date => date.id === dateId).rawDate;
    }
  }
};
</script>

<style lang="scss" scoped></style>
